import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../components/ToastMsg";
import "react-loading-skeleton/dist/skeleton.css";
import styles from '../index.module.css';
import SearchBar from "../../../../components/SearchBar";
import TableSkeleton from "../../../../components/Skeleton";
import { editVehicleStatus, getAllVehicles } from "../../../../redux/features/vehicle/vehicleService";
import Pagination from "../../../../components/Pagination";
import NoResultsFound from "../../../../components/NoResultsFound";
import Modal from "../../../../components/Modal";
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { getAllQuotationList } from "../../../../redux/features/quotation/quotationService";

const Invoices = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isQuotationListLoading, pageCount, quotationList } = useSelector((state) => state.quotation.allQuotationList);

    const [searchQuery, setSearchQuery] = useState('');
    const [skip, setSkip] = useState(0);
    const limit = 10;

    const [selectedCountryId, setSelectedCountryId] = useState(null);
    const [isActivateModalOpen, setActivateModalOpen] = useState(false);
    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);

    const fetchAllQuotations = useCallback(() => {
        dispatch(getAllQuotationList({ id }));
    }, [dispatch, skip]);

    useEffect(() => {
        fetchAllQuotations();
    }, [fetchAllQuotations]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };

    const closeModal = () => setActivateModalOpen(false);
    const closDeactivationModal = () => setDeactivationModalOpen(false);

    const handleYes = async () => {
        setActivateModalOpen(false);
        try {
            const vehicleData = {
                id: selectedCountryId,
                status: "true"
            }
            const response = await dispatch(editVehicleStatus({ vehicleData })).unwrap();
            setSelectedCountryId(null);
            showToast('success', response.message);
            fetchAllQuotations();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }
    const handleRejectYes = async () => {
        setDeactivationModalOpen(false);
        try {
            const vehicleData = {
                id: selectedCountryId,
                status: "false"
            }
            const response = await dispatch(editVehicleStatus({ vehicleData })).unwrap();
            setSelectedCountryId(null);
            showToast('success', response.message);
            fetchAllQuotations();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    const openInvoiceEdit = (invoiceId) => {
        navigate(`/admin/vehicles/${id}/invoices/${invoiceId}`)
    }

    const openInvoice = (document) => {
        window.open(document, "_blank");
    }

    const openVehicleInvoice = (id) => {
        navigate(`/admin/vehicles/invoice/${id}`)
    }

    return (
        <div className={`search-card`}>
            <div className={`search-card-header`}>
                <h1 className={`form-title`}>Invoices</h1>
                <SearchBar onSearch={(query) => setSearchQuery(query)} />
            </div>
            <div className={`search-card-body`}>
                {isQuotationListLoading ?
                    <TableSkeleton columns={["Document Ref", "Bill to Name", "Date", "Actions"]} rowCount={10} height={20} />
                    : quotationList.length > 0 ?
                        <div className={`table-container`}>
                            <table className={`table`}>
                                <thead className={`thead`}>
                                    <tr>
                                        <th className={`theadColumnOne`}>Document Ref</th>
                                        <th>Bill to Name</th>
                                        <th>Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className={`tbody`}>
                                    {quotationList?.map((quotation) => (
                                        <tr key={quotation.id}>
                                            <td className={`tdataColumnOne`}>
                                                {quotation?.document_ref}
                                            </td>
                                            <td>
                                                {quotation.bill_to_name}
                                            </td>
                                            <td>{quotation.date}</td>
                                            <td className={`actionsBtn ${styles.actionCol}`}>
                                                <button className={`btn-edit-label`} onClick={() => {
                                                    openInvoice(quotation.document_url)
                                                }}>View</button>
                                                <button className={`btn-edit-label`} onClick={() => {
                                                    openInvoiceEdit(quotation.id)
                                                }}>Edit</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        :
                        <NoResultsFound />
                }
            </div>
            <div className={`search-card-footer`}>
                {pageCount > 0 && (
                    <div className={styles.paginationContainer}>
                        <Pagination
                            currentPage={skip + 1}
                            totalPages={pageCount}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}
            </div>
            {isActivateModalOpen && (
                <Modal
                    title='Vehicle Activation'
                    onClose={closeModal}
                    onYes={handleYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to activate the Vehicle?`}
                    colorType={`var(--green)`}
                />
            )}
            {isDeactivationModalOpen && (
                <Modal
                    title='Vehicle Deactivation'
                    onClose={closDeactivationModal}
                    onYes={handleRejectYes}
                    isInput={false}
                    iconName={faCircleXmark}
                    bodyText={`Are you sure you want to deactivate the Vehicle?`}
                    colorType={`var(--danger)`}
                />
            )}
        </div>
    );
};

export default Invoices;
